import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BaseConfirmDrawer from '@/components/ui/BaseConfirmDrawer';

type RegistrationModeDrawerProps = {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
    confirmMessage: string;
};

const RegistrationModeDrawer = ({ open, onConfirm, onClose, confirmMessage }: RegistrationModeDrawerProps) => {
    const { t } = useTranslation('common');

    return (
        <>
            <BaseConfirmDrawer
                open={open}
                title={t('Store Status Change')}
                confirmText={t('Confirm')}
                cancelText={t('Cancel')}
                onConfirm={onConfirm}
                onClose={onClose}
            >
                <Typography>{confirmMessage}</Typography>
            </BaseConfirmDrawer>
        </>
    );
};

export default RegistrationModeDrawer;
